const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim() ?? ""
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() ?? ""

export const env = {
  supabaseUrl,
  supabasePublishableKey,
  appUrl: import.meta.env.VITE_APP_URL?.trim() || window.location.origin,
  mockupStudioUrl: import.meta.env.VITE_MOCKUP_STUDIO_URL?.trim() || "https://mockups.barca.cc",
  demoMode:
    import.meta.env.VITE_DEMO_MODE !== "false" ||
    !supabaseUrl ||
    !supabasePublishableKey,
}
